import { render } from "./LoadingScreen.vue?vue&type=template&id=537940c1&scoped=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=537940c1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-537940c1"

export default script